import { render, staticRenderFns } from "./StockMovementsTable.component.vue?vue&type=template&id=270df365&scoped=true&"
import script from "./StockMovementsTable.component.vue?vue&type=script&lang=js&"
export * from "./StockMovementsTable.component.vue?vue&type=script&lang=js&"
import style0 from "./StockMovementsTable.component.vue?vue&type=style&index=0&id=270df365&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270df365",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VDivider,VRow,VSpacer})
